import type { ResponsiveValue } from "@chakra-ui/react"
import { GridItem as GridItemOg } from "@chakra-ui/react"
import {
    componentStyles,
    type PropsWithChildrenAndStyle,
} from "@mallardbay/lib-react-components"
import React from "react"

interface Props extends PropsWithChildrenAndStyle {
    readonly colSpan?: ResponsiveValue<number | "auto">
}

export default function GridItem({ colSpan, style, children }: Props) {
    const styles = useStyleProps()
    const mergedStyles = {
        ...styles.gridItem,
        ...style,
    }
    return (
        <GridItemOg colSpan={colSpan} sx={mergedStyles}>
            {children}
        </GridItemOg>
    )
}

function useStyleProps() {
    return componentStyles({
        gridItem: {
            rounded: "2xl",
        },
    })
}
